import { render } from "./TrainingTableOption.vue?vue&type=template&id=1afc9ada&scoped=true&ts=true"
import script from "./TrainingTableOption.vue?vue&type=script&lang=ts"
export * from "./TrainingTableOption.vue?vue&type=script&lang=ts"

import "./TrainingTableOption.vue?vue&type=style&index=0&id=1afc9ada&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afc9ada"]])

export default __exports__